/**
 * Kopira tekst u međuspremnik.
 *
 * navigator.clipboard postoji samo u sigurnom kontekstu (HTTPS ili localhost), pa na
 * dev okruženju preko običnog http-a nije dostupan. Zato postoji execCommand fallback -
 * deprecated je, ali je jedini način koji radi izvan sigurnog konteksta i u starijim
 * preglednicima.
 *
 * @returns true ako je kopiranje uspjelo
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Dozvola odbijena ili nesiguran kontekst - probaj fallback.
    }
  }

  return legacyCopy(text);
}

function legacyCopy(text: string): boolean {
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    // readonly da se na mobilnim uređajima ne otvori tipkovnica
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.select();
    // iOS Safari ignorira select() na readonly elementu
    textarea.setSelectionRange(0, text.length);

    const copied = document.execCommand('copy');
    document.body.removeChild(textarea);

    return copied;
  } catch {
    return false;
  }
}
